import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Divider, Paper, Typography, Button, Grid, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import HelpIcon from '@material-ui/icons/Help';
import { recordProjectVisit } from '../../utils/projectVisit';
import { getDrafts, getProjects, ProjectState, selectFan, updateProjectDetails, updateFanDetails, updateProjectState, resetProject, updateGADetails, removeProject as removeProject_ , removeDraftProject as removeDraftProject_ } from '../../app/reducer/project.reducer';
import SearchList from '../../components/general/SearchList';
import { useHelp } from '../../utils/HelpContext';
import Tooltip from '../../components/tooltip/Tooltip';

interface IRootState {
  project: ProjectState;
  auth: any;
  history: any;
}

const Projects: React.FC<IRootState> = ({ history }) => {
  const { help } = useHelp(); // Access the help toggle state
  const [activeTooltip, setActiveTooltip] = React.useState<string | null>(null); // Track which tooltip is active

  // Define a type for helpData keys
  type HelpDataKeys = 'NewProject';
  
  // Define helpData with the possible keys
  const helpData: Record<HelpDataKeys, string> = {
    NewProject: "Start new project for a client specifying all the details wrt to fan, blade, hub etc.",
  };

  // Handle tooltip visibility when clicking the "?" button
  const handleTooltipClick = (fieldId: string) => {
    setActiveTooltip((prev) => (prev === fieldId ? null : fieldId)); // Toggle tooltip visibility
  };

  const dispatch = useDispatch();
  const auth = useSelector((state: IRootState) => state.auth);
  let project = useSelector((state: IRootState) => state.project);
  console.log(auth)
 const selectProject = (projectDetails: any, projectState: 'draft' | 'saved') => {
  // record visit first
  if (projectDetails?._id) {
    recordProjectVisit(projectDetails._id, projectState);
  }

  dispatch(updateProjectState(projectState));
  dispatch(updateProjectDetails(projectDetails));
  dispatch(updateFanDetails(projectDetails.fan_form));
  if (projectDetails.ga_details) {
    dispatch(updateGADetails(projectDetails.ga_details));
  }
  if (projectDetails.fan_details) {
    dispatch(selectFan(projectDetails.fan_details));
  }
  history.push('projects/edit');
};

  const removeProject = (projectDetails: any) => {
    dispatch(removeProject_({ id: projectDetails._id }));
    dispatch(getProjects());
  };

  const removeDraftProject = (projectDetails: any) => {
    dispatch(removeDraftProject_({ id: projectDetails._id }));
    dispatch(getDrafts());
  };

  useEffect(() => {
    dispatch(getDrafts());
    dispatch(getProjects());
  }, [dispatch]);

  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper">
          <Typography variant="h2" gutterBottom>
            <b>Projects</b>
          </Typography>
          <Divider />

            <Grid container spacing={1} alignItems="center">
              <Grid item xs={help?11:12}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{fontSize:'18px', width: '100%',backgroundColor:'#48bc97' }}
                  onClick={() => {
                    dispatch(resetProject());
                    history.push('projects/new');
                  }}
                >
                  <AddIcon />
                  &nbsp;Create New project
                </Button>
              </Grid>
              <Grid item xs={1}>
                {help && (
                  <IconButton
                    type="button"
                    onClick={() => handleTooltipClick('NewProject')}
                    color="primary" 
                    style={{ padding: '0px' }}
                  >
                    <HelpIcon />
                  </IconButton>
                )}
                {/* Ensure the Tooltip receives a string from helpData safely */}
                <Tooltip text={helpData['NewProject' as HelpDataKeys]} isVisible={activeTooltip === 'NewProject'} />
              </Grid>
            </Grid>
        
          <Divider style={{ paddingBottom: '20px' }} />
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <SearchList
                btnVariant="primary"
                searchLabel="Drafts"
                busy={project.fetchingDrafts}
                colHeaders={['Name', 'Client Name', 'POC','Created At', 'View', 'Remove']}
                rowKeys={['project', 'customer_name', 'consultant','createdAt']}
                data={project.draftsList}
                cta={(data: any) => selectProject(data, 'draft')}
                ctaRemove={(data: any) => removeDraftProject(data)}
              />
            </Grid>
            <Grid item xs={6}>
              <SearchList
                btnVariant="secondary"
                searchLabel="Projects"
                busy={project.fetchingProjects}
                colHeaders={['Name', 'Client Name', 'POC','Created At', 'View', 'Remove']}
                rowKeys={['project', 'customer_name', 'consultant','createdAt']}
                data={project.projectsList}
                cta={(data: any) => selectProject(data, 'saved')}
                ctaRemove={(data: any) => removeProject(data)}
              />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </div>
  );
};

export default Projects;
